import { useEffect } from 'react';
import Toast from 'react-native-toast-message';
import { useDispatch, useSelector } from 'react-redux';

import { getSocket } from '../../services/socket';
import { RootState } from '../../store';
import { notificationsRequest } from '../../store/userNotifications/notificationsActions';

const NotificationsListener = () => {
	const dispatch = useDispatch();
	const isLoggedIn = useSelector((s: RootState) => !!s.auth?.user);
	const playerId = useSelector((s: RootState) => s.auth?.user?.id || '');
	const username = useSelector((s: RootState) => s.auth?.user?.username || '');

	useEffect(() => {
		if (!isLoggedIn || !playerId || !username) return;

		const socket = getSocket(String(playerId), String(username));

		const handler = (packet: any) => {
			console.log('🔔 [socket] getNotifications', packet);

			const unseenCount = packet?.data?.unseen_notifications ?? packet?.unseen_notifications;
			if (typeof unseenCount === 'number') {
				dispatch(notificationsRequest());
				return;
			}

			if (packet?.success) {
				const notifications = packet.notifications || [];

				if (!Array.isArray(notifications) || notifications.length === 0) return;

				// case 1: single notification
				if (packet.data) {
					Toast.show({
						type: 'success',
						text1: packet.data.title || 'Notification',
						text2: packet.data.body || '',
						position: 'bottom',
						visibilityTime: 3000,
						text1Style: { fontSize: 16 },
						text2Style: { fontSize: 14, color: '#100f14ff' },
					});
					return;
				}

				// case 2: list of notifications

				notifications.forEach(n => {
					Toast.show({
						type: 'success',
						text1: n.title || 'Notification',
						text2: n.message || '',
						position: 'bottom',
						visibilityTime: 3000,
						text1Style: { fontSize: 16 },
						text2Style: { fontSize: 14, color: '#100f14ff' },
					});
				});
			}
		};

		socket.on('getNotifications', handler);

		return () => {
			socket.off('getNotifications', handler);
		};
	}, [dispatch, isLoggedIn, playerId, username]);

	return null;
};

export default NotificationsListener;
